<ng-template #content>
  <ng-content></ng-content>
</ng-template>
<div class="row align-items-end mb-2">
  <div
    class="col-lg-6 col-md-12"
    [ngClass]="{ 'col-lg-6 col-md-12': saveSpaceForErrorMsg, col: !saveSpaceForErrorMsg }"
    >
    <label class="mb-0">
      <strong>
        {{ label }}
        @if (!required && !hasRequiredValidator) {
          <span class="text-description">
            - {{ 'optional' | translate }}
          </span>
        }
        @if (required || hasRequiredValidator) {
          <span class="text-danger fw-bold">*</span>
        }
      </strong>
    </label>
    @if (maxStrLength && control.value) {
      <span class="text-description float-right">
        ({{ control.value.length }} / {{ maxStrLength }} {{ 'Zeichen' | translate }})
      </span>
    }
    @if (!hideInputGroupElements) {
      <div class="input-group">
        <ng-container *ngTemplateOutlet="content"></ng-container>
        @if (control.value) {
          <div (click)="control.setValue(emptyValue)" class="input-group-append cursor-pointer">
            <span class="input-group-text full-height">
              <em class="fas fa-trash"></em>
            </span>
          </div>
        }
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="content"></ng-container>
    }
  </div>
  @if (hasError && control.touched && errorMsg) {
    <div class="col mt-2">
      <div class="alert alert-danger mb-0 p-2 font-08">
        {{ errorMsg }}
      </div>
    </div>
  }
</div>
